import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  getPetsCompliantSummaryWoLoader,
  updateNoteByAppointmentIdWoLoader,
} from "../../../redux/reducers/petSlice";

const UpdateRemarks = ({
  remarksModVsble = false,
  onCloseRemarks,
  remarks = "",
  notes = "",
  id = null,
  facilityId = null,
  facility = null,
}) => {
  const dispatch = useDispatch();
  // const facilities = useSelector((state) => state?.clinic?.facilities);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const [values, setValues] = useState({
    remarks: "",
    notes: "",
    facilityId: facilityId,
    facility: facility,
  });
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { facilities } = useMemo(() => {
    if (!mandateDataRaw) return { facilities: [] };
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        facilities: Array.isArray(reqData?.facilities)
          ? reqData?.facilities
          : [],
      };
    } catch {
      return { facilities: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    setValues({
      remarks,
      notes,
      facility: facilityId
        ? { name: facility, value: facilityId, id: facility }
        : null,
    });
  }, [remarks, notes, facilityId, facility]);

  const onSaveRemarks = () => {
    dispatch(
      updateNoteByAppointmentIdWoLoader({
        id,
        note: values?.notes,
        remarks: values?.remarks,
        facilityId: values?.facility?.id ?? null,
        facility: values?.facility?.name ?? null,
      }),
    ).then((res) => {
      if (res) {
        onCloseRemarks();
        dispatch(getPetsCompliantSummaryWoLoader(id));
      }
    });
  };

  const getFacilitiesByType = (type) => {
    const reqType =
      reqDet?.appointment?.appointmentType === "Home"
        ? "HomeKit"
        : type === "Surgery"
          ? "OperationTheatre"
          : type === "Consultation" ||
              type === "Lab Tests" ||
              type === "Radiology Tests" ||
              type === "Others"
            ? "ConsultationRoom"
            : "BathBays";
    const reqVetList =
      facilities
        ?.filter((fl) => fl?.type?.toLowerCase() !== "devices")
        // ?.filter((fl) => fl?.type === reqType)
        ?.map((fl) => {
          return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
        }) ?? [];
    return reqVetList;
  };

  return (
    <CustomModal
      open={remarksModVsble}
      onClose={onCloseRemarks}
      header="Remarks & Facility"
      modal
      modalWidth={50}
      headerBold
    >
      <div>
        <CustomSelect
          list={getFacilitiesByType(reqDet?.appointment?.serviceType)}
          value={values?.facility}
          handleChange={(e, value) => setValues({ ...values, facility: value })}
          name="facility"
          search
          // helperText={petErrors?.facility}
          // error={!!petErrors?.facility}
          label={values?.consultationMode === "Home" ? "Kit Name" : "Facility"}
          labelTop
        />
      </div>
      <div className="mt20">
        <CustomTextField
          name="remarks"
          fullWidth
          handleChange={(e) =>
            setValues({ ...values, remarks: e?.target?.value })
          }
          value={values?.remarks}
          multiline
        />
      </div>
      <div className="flex1-center mv20">
        <div>
          <CustomButton text="Save" onClick={onSaveRemarks} smallBtn />
        </div>
      </div>
    </CustomModal>
  );
};

export default UpdateRemarks;
